import { render, staticRenderFns } from "./index.component.vue?vue&type=template&id=0c20657b&scoped=true"
import script from "./index.component.js?vue&type=script&lang=js&external"
export * from "./index.component.js?vue&type=script&lang=js&external"
import style0 from "./index.component.vue?vue&type=style&index=0&id=0c20657b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20657b",
  null
  
)

export default component.exports